import React, { useState } from "react";
import "./Testimonials.css";
import { testimonialsData } from "../../data/testimonialsData";
import leftArrow from "../../assets/leftArrow.png";
import rightArrow from "../../assets/rightArrow.png";
import { motion } from "framer-motion";

const Testimonials = () => {
  const transition={type:"spring" , duration:3}
  const [selected, setSelected] = useState(0);
  const tLength = testimonialsData.length;
  return (
    <div className="testimonial" id="Testimonials">
      <div className="left-t">
        <span>TESTIMONIALS</span>
        <span className="stroke-text">WHAT THEY </span>
        <span>SAY ABOUT US</span>
        {/* <span>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Rem distinctio iste praesentium velit? .</span> */}
        <motion.span
                          key={selected}
                          initial={{opacity:0,x:-100 }}
                          animate={{opacity:1,x:0}}
                          transition={{...transition , duration:2}}
                          exit={{opacity:0, x:  100}}
        >{testimonialsData[selected].review}</motion.span>
        <span>
          <motion.span
                  key={selected}
                  initial={{opacity:0,x:-100 }}
                  animate={{opacity:1,x:0}}
                  transition={{...transition , duration:1}}
                  exit={{opacity:0, x:  100}}
          style={{ color: "var(--orange)" }}>
            {testimonialsData[selected].name}
          </motion.span>{" "}
          - {testimonialsData[selected].status}
        </span>
      </div>
      <div className="right-t">
        <motion.div
        initial={{opacity:0,x:-100 }}
        transition={{...transition , duration:2}}
        whileInView={{opacity:1, x:0}}></motion.div>
        <motion.div
        initial={{opacity:0,x:100 }}
        transition={{...transition , duration:2}}
        whileInView={{opacity:1, x:0}}></motion.div>
        <motion.img
        key={selected}
        initial={{opacity:0,x:100 }}
        animate={{opacity:1,x:0}}
        transition={{...transition , duration:2}}
        exit={{opacity:0, x:-100}}
        
        src={testimonialsData[selected].image} alt="" />
        <div className="arrow">
          <img
            onClick={() => {
              selected === 0
                ? setSelected(tLength - 1)
                : setSelected((prev) => prev - 1);
            }}
            src={leftArrow}
            alt=""
            className="leftArrow"
          />
          <img
          onClick={()=>{
            selected ===tLength-1 ? setSelected(0) : setSelected((pre)=> pre + 1)
          }} 
          src={rightArrow} alt="" className="rightArrow" />
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
